import { Flame } from "lucide-react";

export const TrendingBadge = ({ testid, className = "" }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center gap-1.5 rounded-full bg-[var(--ember)] px-3 py-1 font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-[var(--ink)] ${className}`}
  >
    <Flame className="h-3 w-3 fill-current" /> Trending
  </span>
);
